import React, { useEffect, useState } from 'react'
import Cleave from 'cleave.js/react'
import 'cleave.js/dist/addons/cleave-phone.br'
import * as _ from 'lodash'
import PropTypes from 'prop-types'
import API from '../Utils/api'
import { Link } from 'react-router-dom';


import { generatePassword, validateCPF, validateEmail } from '../Utils/validation'

const FormGerenteCambista = ({redirect, perfil, tutorId, admin, id = null }) => {
    const initialState = {
        nome: '',
        email: '',
        telefone: '',
        comissao: perfil === 'CAMBISTA'? JSON.parse(localStorage.getItem("user")).comissaoBaseVendedor : 0,
        cpf: '',
        endereco: '',
        bairro: '',
        cidade: '',
        estado: '',
        status: 'true',
        vendedorApp: true,
        adminId: admin? admin._id : null,
        comissaoBaseVendedor: 1,
        comissão: 0,
        isApp: JSON.parse(localStorage.getItem("user")).isApp
    }
    const [resetSenha, setResetSenha] = useState(false)
    const [form, setForm] = useState(initialState)
    const [errors, setErrors] = useState({ nome: '', email: '', cpf: '' })
    const [cleaves, setCleaves] = useState({
        cpfCleave: null,
        telefoneCleave: null,
        emailCleave: null
    })

    useEffect(() => {
        buscarCambistaPeloId(id)
    }, [id])

    const buscarCambistaPeloId = async id => {
        if (id != null) {
            const { data } = await API.get(`/api/usuarios/${id}`)
            if (data) {
                const status = data.status ? 'true' : 'false'

                setForm(prevState => {
                    return {
                        ...prevState,
                        ...data,
                        status
                    }
                })
            }
        }

    }

    const validateFields = ({ cpf, nome, email }) => {
        const errors = {}
        // console.log(cpf)
        // if (cpf.length < 11) {
        //     errors['cpf'] = 'Este CPF é inválido'
        // } 
        // else  if (cpf == '') {
        //     errors['cpf'] = 'CPF é um campo obrigatório'
        // }
        if (!nome) errors['nome'] = 'Nome é um campo obrigatório'
        if (nome && nome.length <= 3) errors['nome'] = 'Nome muito curto'
        if (!email) errors['email'] = 'Email é um campo obrigatório'
        if (!validateEmail(email)) errors['email'] = 'Email inválido'

        setErrors({ ...errors })
    }

    const telefoneInit = (cleave) => {
        setCleaves(prevState => {
            return {
                ...prevState,
                telefoneCleave: cleave,
            }
        })
    }

        const cpfInit = (cleave) => {
            setCleaves(prevState => {
                return {
                    ...prevState,
                    cpfCleave: cleave,
                }
            })
        }

    const emailInit = (cleave) => {
        setCleaves(prevState => {
            return {
                ...prevState,
                emailCleave: cleave,
            }
        })
    }

    const handleResetForm = event => {
        setForm(initialState)
        setErrors({})
        setResetSenha(false)
        for (let key in cleaves) {
            cleaves[key].setRawValue('')
        }
        Object.entries(cleaves).forEach((kv) =>{
            cleaves[kv[0]].setRawValue('')
        })
    }

    const handleInputChange = event => {
        const { name, value } = event.target
        setForm(prevState => {
            return {
                ...prevState,
                [name]: value
            }
        })
    }

    const handleResetSenha = event => {
        const { checked } = event.target
        setResetSenha(checked)
    }

    const handleRequiredCleaveLength = event => {
        const minLength = event.target.dataset.length
        const { name, rawValue } = event.target

        if (rawValue && rawValue.length < minLength) {
            setForm(prevState => {
                return {
                    ...prevState,
                    [name]: ''
                }
            })
            cleaves[`${name}Cleave`].setRawValue('')
        }
    }

    const validateForm = async () => {
        validateFields({ ...form })
    }

    const handleSubmit = async event => {
        event.preventDefault()
        let senha = ''
        const status = form.status === 'true'

        if (_.isEmpty(errors)) {
            const { data } = await API.get('/api/parametros')
            let comissao
            switch (perfil) {
                case 'GERENTE':
                    comissao = data ? data.baseComissaoGerente : 0
                    break
                case 'CAMBISTA':
                    comissao = data ? data.baseComissaoCambista : 0
                    break
                default:
                    comissao = 0
            }

            if (!id) {
                senha = generatePassword()
                const response = await API.post('/api/usuarios', {
                    ...form, tutorId, perfil, senha, status, comissao
                })

                const responseError = response.data.error
                if (responseError) {
                    alert(responseError)
                    return
                }
            } else {
                // atualizar o registro
                const dados = { ...form, tutorId: tutorId, perfil, status, usuarioId: id }
                var response;
                if (resetSenha) {
                    senha = generatePassword()
                    dados['senha'] = senha
                    response = await API.post('/api/usuarios/atualizar-usuario', {...dados})
                }
                else {
                    response = await API.post('/api/usuarios/atualizar-usuario-manter-senha', {...dados})
                }

                if(JSON.parse(localStorage.getItem("user")).perfil === "ADMIN" || JSON.parse(localStorage.getItem("user")).perfil === "MASTER"){
                    gerenteUpdateBaseComissaoCambista();
                    gerenteUpdateBaseModoVendaCambista();
                 }

                if (response.data === 1) {
                    let message = 'Registro atualizado com sucesso.'
                    if (resetSenha) message = message.concat(`\nAnote sua nova senha: ${senha}`)
                    alert(message)
                    window.location.href = window.localStorage.getItem("returnRoute")?  window.localStorage.getItem("returnRoute") :  redirect
                    // if(JSON.parse(localStorage.getItem("user")).perfil === "MASTER"){
                    //     window.location.href = "/master-gerencia-gerentes"
                    // }
                    // else if(JSON.parse(localStorage.getItem("user")).perfil === "ADMIN"){
                    //     window.location.href = "/admin-gerenciar-gerentes"
                    // }
                    // else{
                    //     window.location.href = redirect;
                    // }
                }
            }

            handleResetForm()

            if (!id) {
                alert(`
Cadastro realizado com sucesso.
Obs.: Anote a senha: ${senha}, email: ${form.email}
                `)
            }
        }
    }



   const gerenteUpdateBaseComissaoCambista = async () =>{
        if(id){
            try {

                    const result = await API.post('/api/usuarios/gerente-update-comissao-cambista', {gerenteId: form._id , comissao: form.comissaoBaseVendedor})
            } catch (error) {
                console.log(error)
            }
        }
    }

    const gerenteUpdateBaseModoVendaCambista = async () =>{
        if(id){
            try {

                    const result = await API.post('/api/usuarios/gerente-update-modo-de-venda-cambista', {gerenteId: form._id , vendedorApp: form.vendedorApp})
            } catch (error) {
                console.log(error)
            }
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="form-group col-lg-9">
                    <label htmlFor="nome">NOME</label>
                    <input type="text" name="nome"
                           onChange={handleInputChange}
                           value={form.nome || ''}
                           className={`form-control ${errors.nome && 'is-invalid'}`} placeholder="Nome"/>
                    <div className="invalid-feedback">
                        {errors.nome}
                    </div>
                </div>
                <div className="form-group col-lg-3">
                    <label htmlFor="cpf">CPF</label>
                    <Cleave placeholder="999.999.999-99"
                            value={form.cpf || ''}
                            name="cpf" data-length="11"
                            onInit={cpfInit}
                            className={`form-control ${errors.cpf && 'is-invalid'}`}
                            options={{
                                numericOnly: true,
                                delimiters: ['.', '.', '-'],
                                blocks: [3, 3, 3, 2]
                            }}
                            onChange={handleInputChange}
                            onBlur={handleRequiredCleaveLength}
                    />
                    <div className="invalid-feedback">
                        {errors.cpf}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="form-group col-lg-9">
                    <label htmlFor="email">EMAIL</label>
                    <Cleave name="email" placeholder="email@email.com" onInit={emailInit}
                            value={form.email || ''}
                            className={`form-control ${errors.email && 'is-invalid'}`}
                            options={{
                                lowercase: true,
                            }}
                            onChange={handleInputChange}
                    />
                    <div className="invalid-feedback">
                        {errors.email}
                    </div>
                </div>
                <div className="form-group col-lg-3">
                    <label htmlFor="telefone">TELEFONE</label>
                    <Cleave name="telefone"
                            placeholder="99 99999 9999"
                            data-length="10"
                            value={form.telefone || ''}
                            onInit={telefoneInit}
                            className="form-control"
                            options={{
                                phone: true,
                                phoneRegionCode: 'BR'
                            }}
                            onChange={handleInputChange}
                            onBlur={handleRequiredCleaveLength}
                    />
                </div>

            </div>
            {JSON.parse(localStorage.getItem("user")).perfil === "ADMIN" || JSON.parse(localStorage.getItem("user")).perfil === "MASTER" ? 
                <div className="row">
                        <div className="form-group col-lg-3">  
                          <div className="form-group col-lg-7">
                              <label htmlFor="comissao">Comissão do gerente R$:</label>
                              <input type="number" name="comissao" className="form-control" placeholder={form.comissao || 0}
                                     value={form.comissao || 0}
                                     onChange={handleInputChange}/>
                          </div>
                          </div>
                          <div className="form-group col-lg-3">      
                            <div className="form-group col-lg-7">
                                <label htmlFor="comissaoBaseVendedor">Comissão dos vendedores R$:</label>
                                <input type="number" name="comissaoBaseVendedor" className="form-control" placeholder={form.comissaoBaseVendedor || 0}
                                        value={form.comissaoBaseVendedor || 0}
                                        onChange={handleInputChange}/>
                            </div>
                          </div>
                  </div>  : <div></div>
            }

     

            <div className="row">
                <div className="form-group col-lg-7">
                    <label htmlFor="endereco">Endereço</label>
                    <input type="text" name="endereco" className="form-control" placeholder="Endereço"
                           value={form.endereco || ''}
                           onChange={handleInputChange}/>
                </div>
                <div className="form-group col-lg-5">
                    <label htmlFor="bairro">Bairro</label>
                    <input type="text" name="bairro" className="form-control" placeholder="Bairro"
                           value={form.bairro || ''}
                           onChange={handleInputChange}/>
                </div>
            </div>
            <div className="row">
                <div className="form-group col-lg-4">
                    <label htmlFor="cidade">Cidade</label>
                    <input type="text" name="cidade" className="form-control" placeholder="Cidade"
                           value={form.cidade || ''}
                           onChange={handleInputChange}/>
                </div>
                <div className="form-group col-lg-4">
                    <label htmlFor="estado">Estado</label>
                    <input type="text" name="estado" className="form-control" placeholder="Estado"
                           value={form.estado || ''}
                           onChange={handleInputChange}/>
                </div>
                <div className="form-group col-lg-4">
                    <label htmlFor="status">Status</label>
                    <select id="status" name="status"
                            onChange={handleInputChange}
                            value={form.status}
                            className="form-control custom-select"
                            style={{ height: 'calc(2.25rem + 4px)' }}>
                        <option value="">Selecione...</option>
                        <option value="true">Ativo</option>
                        <option value="false">Bloqueado</option>
                    </select>
                </div>
            </div>

            {JSON.parse(localStorage.getItem("user")).perfil == "GERENTE" && !JSON.parse(localStorage.getItem("user")).vendedorApp && perfil == "CAMBISTA"?
            <div className="row">
                <div className="form-group col-lg-4">
                    <label htmlFor="status">Modo de venda</label>
                    <select id="vendedorApp" name="vendedorApp"
                            onChange={handleInputChange}
                            value={form.vendedorApp}
                            className="form-control custom-select"
                            style={{ height: 'calc(2.25rem + 4px)' }}>
                        <option value="">Selecione...</option>
                        <option value={true}>Pré-pago</option>
                        <option value={false}>Pós-pago</option>
                    </select>
                </div>
            </div> : <div></div>}


            {perfil == "GERENTE"?
            <div className="row">
                <div className="form-group col-lg-4">
                    <label htmlFor="status">Modo de venda</label>
                    <select id="vendedorApp" name="vendedorApp"
                            onChange={handleInputChange}
                            value={form.vendedorApp}
                            className="form-control custom-select"
                            style={{ height: 'calc(2.25rem + 4px)' }}>
                        <option value={null}>Selecione...</option>
                        <option value={true}>Pré-pago</option>
                        <option value={false}>Pós-pago</option>
                    </select>
                </div>
            </div> : <div></div>}
            
            {id && (
                <div className="row">
                    <div className="col-lg-12">
                        <input type="checkbox" id="exampleCheck1" checked={resetSenha} onChange={handleResetSenha}/>
                        <label className="form-check-label" htmlFor="exampleCheck1">Gerar nova senha ao salvar</label>
                    </div>
                </div>
            )}
            <div className="float-lg-right">
                <button type="reset" onClick={handleResetForm} className="btn btn-fill btn-secondary">Cancelar
                </button>
                <button type="submit" onClick={validateForm}
                        className="btn btn-fill btn-success ml-lg-1 ml-md-1">Salvar
                </button>
            </div>
            <div className="clearfix"></div>
        </form>
    )
}

FormGerenteCambista.propTypes = {
    perfil: PropTypes.oneOf(['GERENTE', 'CAMBISTA']).isRequired,
    tutorId: PropTypes.string,
    id: PropTypes.string
}

export default FormGerenteCambista